import { render, staticRenderFns } from "./BookingReportBaseComponent.vue?vue&type=template&id=64b8cac4&scoped=true&"
import script from "./BookingReportBaseComponent.vue?vue&type=script&lang=js&"
export * from "./BookingReportBaseComponent.vue?vue&type=script&lang=js&"
import style0 from "./BookingReportBaseComponent.vue?vue&type=style&index=0&id=64b8cac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8cac4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b8cac4')) {
      api.createRecord('64b8cac4', component.options)
    } else {
      api.reload('64b8cac4', component.options)
    }
    module.hot.accept("./BookingReportBaseComponent.vue?vue&type=template&id=64b8cac4&scoped=true&", function () {
      api.rerender('64b8cac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/Report/BookingReportBaseComponent.vue"
export default component.exports